// LoginPage.tsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../Loader";
import { Bounce, toast, ToastContainer } from "react-toastify";
import { useFetch, usePOST } from "../../../ApiS";
import Input from "../../Inputs/Input";
import PasswordInput from "../../Inputs/Passwordinput";
import AddImage from "../../../ApiS/AddImage/AddImage";
import AddFiles from "../../AddFiles/AddFiles";

interface Admin {
  id: number;
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  password_confirmation: string;
  old_password: string;
  phone_number: string;
  images: Image[];
}
interface Image {
  id?: string;
  file?: string;
  name?: string;
  value?: string;
}

interface ProfileAdmin {
  total: number;
  per_page: number;
  data: Admin;
}

const EditProfile: React.FC = () => {
  const navigate = useNavigate();
  const [oldImages, setOldImages] = useState({});
  const notify = (message: string) => {
    toast.error(message, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
    });
  };
  const { data } = useFetch("admin/profile", "profile");

  let dataOld = data?.data;

  const {
    mutation,
    handleChangeInput,
    handleSubmit,
    setFormData,
    formData,
    viewFile,
    setViewFile,
    viewFiles,
    setViewFiles,
    handleChangeArrayFiles,
  
  } = usePOST(
    {
      _method: "PUT",
      username: dataOld?.username || "",
      first_name: dataOld?.first_name || "",
      last_name: dataOld?.last_name || "",
      email: dataOld?.email || "",
      password: dataOld?.password || "",
      password_confirmation: dataOld?.password_confirmation || "",
      old_password: dataOld?.old_password || "",
      phone_number: dataOld?.phone_number || "",
    },
    () => navigate("/"),
    () => notify("الرجاء ادخال المعلومات بشكل صحيح ")
  );

  const [userImages, setUserImages] = useState(dataOld?.images[0]);

  useEffect(() => {
    setUserImages(dataOld?.images!);
  }, [dataOld?.images]);

  return (
    <div className="flex-col items-center justify-center bg-gray-100 mt-2  mb-36">
      <ToastContainer />
      {mutation.isLoading ? <Loader /> : ""}

      <h1 className="text-xl font-semibold text-center my-2">
        تغيير البروفايل
      </h1>
      <div className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 w-[55%] max-md:w-[97%]  mx-auto h-full">
        <div className="mb-4">
          <Input
            type="name"
            name="username"
            onChange={handleChangeInput}
            title="     اسم المستخدم"
            placeholder="أدخل اسم المستخدم"
            className="!w-full"
            defaultValue={formData.username}
          />
        </div>
        <div className="mb-4">
          <Input
            type="name"
            name="first_name"
            onChange={handleChangeInput}
            title="الأسم الأول"
            placeholder="أدخل الأسم الأول"
            className="!w-full"
            defaultValue={formData.first_name}
          />
        </div>
        <div className="mb-4">
          <Input
            type="name"
            name="last_name"
            onChange={handleChangeInput}
            title="الأسم الأخير"
            placeholder="أدخل الأسم الأخير"
            className="!w-full"
            defaultValue={formData.last_name}
          />
        </div>
        <div className="mb-4">
          <Input
            type="email"
            name="email"
            onChange={handleChangeInput}
            title="البريد الألكتروني"
            placeholder="أدخل  البريد ألألكتروني"
            className="!w-full"
            defaultValue={formData.email}
          />
        </div>
        <div className="mb-4">
          <PasswordInput
            name="password"
            onChange={handleChangeInput}
            title="كلمة المرور"
            placeholder="أدخل كلمة المرور"
            defaultValue={formData.password}
          />
        </div>
        <div className="mb-4">
          <PasswordInput
            name="password_confirmation"
            onChange={handleChangeInput}
            title="تأكيد كلمة المرور"
            placeholder="تأكيد كلمة المرور"
            defaultValue={formData.password_confirmation}
          />
        </div>
        <div className="mb-4">
          <PasswordInput
            name="old_password"
            onChange={handleChangeInput}
            title="كلمة المرور القديمة"
            placeholder="أدخل كلمة المرور القديمة"
            defaultValue={formData.old_password}
          />
        </div>

        <div className="mb-4">
          <Input
            type="number"
            name="phone_number"
            onChange={handleChangeInput}
            title="رقم الهاتف "
            placeholder="أدخل رقم الهاتف"
            className="!w-full"
            defaultValue={formData.phone_number}
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 font-bold mb-2" htmlFor="image">
            أضف صور الشخصية
          </label>
          <AddImage
            type="IMAGE"
            id="image"
            title="أضف الصورة الشخصية"
            name="image"
            onChange={(event) =>
              handleChangeInput(event, "image")
            }
            oldImage={userImages}
            newImage={viewFile["image"]?.image}
            clickDeleteImage={() => {
              setViewFile((prev) => ({
                ...prev,
                image: { image: "" },
              }));
              setFormData((prev) => ({
                ...prev,
                image: "",
              }));
            }}
            clickDeleteOldImage={() => {
              setUserImages(null);
            }}
          />
          {/* <AddFiles
            type={"pdf"}
            name="files[]"
            newImages={viewFiles}
            setnewImages={setViewFiles}
            setFormData={setFormData}
            onChange={handleChangeArrayFiles}
            setImagesToSend={setFiles}
            formData={formData}
            counter={counter}
            setCounter={setCounter}
            setOldImages={setOldImages}
            viewImages={viewFiles}
            setViewImages={setViewFiles}
            images={userImages}
            setUserImages={setUserImages}
            imagesToSend={files}
          /> */}
        </div>

        <div>
          <button
            className="w-[30%]  bg-primary rounded-xl text-white font-bold p-2 "
            onClick={() => handleSubmit("admin/profile/update")}
          >
            حفظ
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
